import { render, staticRenderFns } from "./ChronicDetail.vue?vue&type=template&id=4d02985a"
import script from "./ChronicDetail.vue?vue&type=script&lang=js"
export * from "./ChronicDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports